'use strict';

export default class Newsletter {
    constructor() {



        setTimeout(function () {
            if ($('#webform-submission-c8-mailchimp-form-ajax').length) {

                const input = document.getElementById('edit-email-address');  // replace 'id' with id of email field
                const queryString = window.location.search;
                const urlParams = new URLSearchParams(queryString);  //parse the query string
                const email = urlParams.get('email');  // Store the parsed email address in variable
                input.value = email;  // fill the form with the email address

            }

        }, 2000)

    }
}
